import React from 'react';

import PropTypes from 'prop-types';
import Nav from 'react-bootstrap/Nav';
import { Link } from 'react-router-dom';

import SafelyRenderHtml from '@src/services/renderEditorText';

const HeaderMenuBottomBar = ({
    menus,
    hoverActive,
    hoverMenuId,
    onMouseOver,
    onFocus,
    onClick,
}) => {
    let topLevelNavLinkClassName;

    return (
        <Nav className="mx-auto">
            {
                menus.map((menu, idx) => {
                    if (hoverActive && hoverMenuId === menu.id) {
                        topLevelNavLinkClassName = 'nav-item align-middle active-top-level';
                    } else {
                        topLevelNavLinkClassName = 'nav-item align-middle';
                    }

                    return (
                        <Nav.Link
                            key={`nav-link-${menu.url}`}
                            id={`nav-link-${menu.id}`}
                            menuindex={menu.id}
                            tabIndex={1000 + idx}
                            eventKey={`nav-link-${menu.id}`}
                            as={Link}
                            to={menu.url}
                            className={topLevelNavLinkClassName}
                            onMouseOver={onMouseOver}
                            onFocus={onFocus}
                            onClick={onClick}
                        >
                            { SafelyRenderHtml(menu.displayName) }
                            { menu.id !== 'guides_and_manuals' && <span /> }
                        </Nav.Link>
                    );
                })
            }
        </Nav>
    );
};

HeaderMenuBottomBar.propTypes = {
    menus: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        displayName: PropTypes.string.isRequired,
    })).isRequired,
    hoverActive: PropTypes.bool,
    hoverMenuId: PropTypes.string,
    onMouseOver: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default React.memo(HeaderMenuBottomBar);
